import { Component, OnInit } from '@angular/core';
import { SupplierService } from '../../../services/supplier/supplier.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-suppliers',
  templateUrl: './supplier.component.html'
})
export class SupplierComponent implements OnInit {

  public show = 'list';
  public selectedSupplier = null;
  public labelButtonBack = '';

  constructor(public svc: SupplierService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.translate.get([
      'common.back'
    ]).subscribe((res) => {
      this.labelButtonBack = res['common.back'];
    });
  }

  showBrand ($event) {
    this.show = 'brand';
    this.selectedSupplier = $event;
  }

  showCertification ($event) {
    this.show = 'certification';
    this.selectedSupplier = $event;
  }

  showList ($event) {
    this.show = 'list';
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/supplier/supplier.component.ts